import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class DescriptionQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.DESCRIPTION;
  title: string;
  text: string;

  constructor(options: any = {}) {
    super(options);
    this.title = options['options'].title ? options['options'].title : '';
    this.text = options['options'].text ? options['options'].text : '';
  }
}
